if (!customElements.get('tabs-list')) {
  customElements.define(
    'tabs-list',
    class Tabs extends HTMLElement {
      selectedTab = 1;

      constructor() {
        super();
      }

      connectedCallback() {
        this.setSelectedTab();
        this.initTabsLinks();
        this.initTabs();
      }

      setSelectedTab() {
        const searchParams = new URLSearchParams(window.location.search);
        const tab = parseInt(searchParams.get('tab'));
        this.selectedTab = tab > 0 && tab <= this.querySelectorAll('.tabs__item').length ? tab : 1;
      }

      initTabsLinks() {
        const $tabsLinks = document.createElement('div');
        $tabsLinks.classList.add('tabs__links');

        const animateLinks = Boolean(this.dataset.animateLinks);
        const tabStyle = this.dataset.tabStyle;

        this.querySelectorAll('.tabs__item').forEach(($tab, index) => {
          const searchParams = new URLSearchParams(window.location.search);

          // Create a new tab link with content
          const $tabLink = document.createElement('a');
          $tabLink.classList.add(`tabs__item-link--${tabStyle}`);
          $tabLink.innerText = $tab.getAttribute('data-title');
          $tabLink.role = 'tab';

          if (animateLinks) {
            $tabLink.classList.add('scroll-trigger', 'animate--slide-in');
            $tabLink.setAttribute('data-cascade', '');
            $tabLink.style.setProperty('--animation-order', index);
          }

          if (this.selectedTab === index + 1) {
            $tabLink.ariaSelected = true;
            $tabLink.setAttribute('href', `#`);
            $tabLink.classList.add('active');
          } else {
            // Add link to the tab link
            searchParams.set('tab', index + 1);
            $tabLink.setAttribute('href', `?${searchParams.toString()}`);
          }

          $tabsLinks.insertAdjacentElement('beforeend', $tabLink);
        });

        this.insertAdjacentElement('afterbegin', $tabsLinks);
      }

      initTabs() {
        this.querySelectorAll('.tabs__item').forEach(($tab, index) => {
          if (this.selectedTab == index + 1) {
            $tab.classList.add('tabs__item--active');
          } else {
            $tab.classList.remove('tabs__item--active');
          }
        });

        this.updateHeaderTitle();
      }

      updateHeaderTitle() {
        const $activeTab = this.querySelector('.tabs__item--active');
        const $tabTitle = document.querySelector('.tabs__title');
        if ($activeTab && $tabTitle) {
          $tabTitle.innerText = $activeTab.getAttribute('data-title');
        }
      }
    }
  );
}

if (!customElements.get('tabs-item')) {
  customElements.define(
    'tabs-item',
    class Tab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {}
    }
  );
}
